import { requestWithToken } from "../apiConfigs/request";

export const fetchNotifications = (entityId) => {
  return requestWithToken({
    url: `/notifications`,
    method: 'GET',
    params: entityId ? { entityId } : undefined,
  });
}

export const deleteNotification = (notificationId) => {
  return requestWithToken({
    url: `/notifications/${notificationId}`,
    method: 'PATCH',
  });
}

export const markAsReadNotifications = () => {
  return requestWithToken({
    url: `/notifications`,
    method: 'PATCH',
  });
}